var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('b',[_vm._v(_vm._s(this.thour)+" : "+_vm._s(this.tmin)+" : "+_vm._s(this.tsec))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }